module.exports = __webpack_public_path__ + "static/media/5.0dba78e1.png";